import { Component, OnInit, Injector } from '@angular/core';
import * as _ from 'lodash';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { COMMON_CONSTANTS, API_PARAMS_CONST } from '../../../common/core/common.constants';
import { isNullOrUndefined } from 'src/app/services/utils';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ServiceAgreementComponent } from '../../../shared/components/service-agreement/service-agreement.component';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { RateplanDetails } from '../../../common/models/data.model';
import { UtilsService } from 'src/app/services/utils.service';
import { DataSharingService } from 'src/app/services/data-sharing.service';
import { environment } from 'src/environments/environment';
import { PDLService } from 'src/app/services/pdl-service.service';
import { WindowServiceService } from 'src/app/services/window-service.service';
import { ManageLineService } from 'src/app/services/manage-line.service';

@Component({
  selector: 'app-reviewchangeservice',
  templateUrl: './reviewchangeservice.component.html',
  styleUrls: ['./reviewchangeservice.component.scss']
})
export class ReviewchangeserviceComponent implements OnInit {
  public servicesListCurrentState = [];
  public initialServicesList = [];
  public authoringContentData: any;
  public authToken: any;
  public orgID: any;
  public ngbModalOptions: NgbModalOptions;
  public removedServices = [];
  public serviceAgreementUrl: any;
  public showRemainingServices = false;
  public submitResponse: any;
  public displayServiceTerms = false;
  public TermsUrl: any;
  public termsAndConditionsText: any;
  public termsText: any;
  public serviceTermsText: any;
  public serviceAgreementData: any;
  public totalCurrentServices = 0;
  public ratePlansDetailsList = new Array();
  public ratePlansAddedList = new Array();
  public ratePlansRemovedList = new Array();
  public nextBillCycleStartDate: any;
  public currentPSTDate: any;
  public nextBillingCycleDateUTC: any;
  public serviceInitialList: any;
  public subscriberData: any;
  public reviewChangeServiceData: any;
  public isSubmitEnable = false;
  public isServiceSuccess = false;
  public count = 0;
  public isEdited = false;
  public previousServicesTotal = 0;
  public currentServicesTotal = 0;
  public displayBillingDateInReviewScreen: any;
  public monthNames: any;
  public month: any;
  public dayIndex: any;
  public yearIndex: any;
  public dateItems: any;
  public currentServicesOnLoad: any;
  public addedServicesfromStorage: any
  public removedServicesfromStorage: any;
  ratePlansAddedListforApi: any;
  ratePlansRemovedListforAPi: any;
  currentSelectedService: any
  effectiveTodayService: any
  effectiveNextBillCycleService: any
  lineDetails: any;
  public enableMultiPromo: boolean = false;
  promoListfromStorage: any;
  promotionLists = [];
  promoArray = {};
  sanitizer: DomSanitizer;
  _changeSvc: ChangeServiceService;
  modalService: NgbModal;
  utilsSvc: UtilsService;
  dataSharingSvc: DataSharingService;
  _cacheSvc: HttpCacheService;
  pdlService: PDLService;
  _windowService: WindowServiceService;
  isSpectrumBarterBan: boolean = false;
  manageLineService: ManageLineService;

  constructor(
    private injector : Injector) {
      this.sanitizer = this.injector.get<DomSanitizer>(DomSanitizer);
      this._changeSvc = this.injector.get<ChangeServiceService>(ChangeServiceService);
      this.modalService = this.injector.get<NgbModal>(NgbModal);
      this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
      this.dataSharingSvc = this.injector.get<DataSharingService>(DataSharingService);
      this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
      this.pdlService = this.injector.get<PDLService>(PDLService);
      this._windowService = this.injector.get<WindowServiceService>(WindowServiceService);
    this.authToken = !isNullOrUndefined(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY)) ?
      COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ACCESS_TOKEN_KEY) : '';
    this.orgID = API_PARAMS_CONST.B2B_ORG_ID;
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
  }

  ngOnInit() {
    this.enableMultiPromo = environment.ENABLE_EVALUATE_PROMOTION;
    this._changeSvc.triggerPromoApi.next(false);
    this.initialAssignments();
    _.each(_.get(this, COMMON_CONSTANTS.SERVICES.SERVICES_LIST_CURRENT_STATE), (pkg) => {
      this.totalCurrentServices = pkg?.currentService ? this.totalCurrentServices + 1 : this.totalCurrentServices;
    });
    this.currentSelectedService = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SERVICES.CURRENT_SELECTED_SERVICES));
    this.effectiveTodayService = this.currentSelectedService.filter(service => service?.effectiveToday === true );
    this.effectiveNextBillCycleService = this.currentSelectedService.filter(service => service?.effectiveToday !== true );
    this.constructReviewData();
    this.pdlService.ifEnabledGeneratePageViewTag(this._windowService.location.pathname);
    this.checkIsSpectrumBarterAndEnableSubmit();
  }

  initialAssignments() {
    this.authoringContentData = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.CONTENT));
    this.servicesListCurrentState = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.SERVICES_LIST_CURRENT_STATE));
    this.initialServicesList = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.INITIAL_SERVICES_LIST));
    this.reviewChangeServiceData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SERVICES.REVIEW_CHANGE_SERVICE_DATA));
    this.nextBillCycleStartDate = _.get(this.reviewChangeServiceData, 'nextBillCycleStartDate', '');
    this.removedServices = _.differenceWith(this.initialServicesList, this.servicesListCurrentState, _.isEqual);
    this.removedServices = _.remove(this.removedServices as any[], function (n) {
      return n.currentService === true;
    });
    this.showRemainingServices = this.removedServices.length > 0;
    this.subscriberData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.SUBSCRIBER_DATA));
    this.currentServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.CURRENT_SERVICES_TOTAL));
    this.previousServicesTotal = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.PREVIOUS_SERVICES_TOTAL));
    this.currentServicesOnLoad = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.CURRENT_SERVICE_ON_LOAD));
    this.addedServicesfromStorage = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.ADDED_SERVICES));
    this.removedServicesfromStorage = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.REMOVED_SERVICES));
    this.lineDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.LINE_DETAILS));
    this.promoListfromStorage = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.SERVICES.DESC_DETAILS));
    this.isSpectrumBarterBan = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.IS_SPECTRUM_BARTER));
    this.getPortInPST_Date();
  }
  getPortInPST_Date() {
      this.manageLineService.getPortInPST_Date().subscribe((response) => {
        if (response) {
          this.currentPSTDate = response.currentPstDate;
        }
      }, (error) => {
        this.utilsSvc.errorHandling(error);
      });
  }
  checkIsSpectrumBarterAndEnableSubmit(): any {
    if(environment.ENABLE_SPECTRUM && this.isSpectrumBarterBan) {
      this.isSubmitEnable = true;
    }
  }

  isServicesEdited() {
    this.isEdited = !this.isEdited;
  }


  callServiceAgreementAndTerms() {
    if (this.isEdited) {
      this.ServiceAgreement(true);
    } else {
      this.isSubmitEnable = false;
    }
  }

  ServiceAgreement(isChecked: any) {
    this._changeSvc.getServiceAgreement(this.ratePlansDetailsList).subscribe(response => {
      if (isChecked) {
        this.isServiceSuccess = true;
      }
      this.isSubmitEnable = (this.isServiceSuccess);
      this.serviceAgreementData = response;
      this.serviceTermsText =
        atob(this.serviceAgreementData.documentSet.documents.attachments.embeddedData.binaryContent);
      this.serviceTermsText = this.sanitizer.bypassSecurityTrustHtml(this.serviceTermsText);
      this.dataSharingSvc.sendDataGeneric(new Map<string, any>().set(COMMON_CONSTANTS.SERVICE_AGREEMENT_DATA, response));
      if (!isChecked) {
        this.ngbModalOptions = {
          backdrop: 'static',
          keyboard: false,
          centered: false,
          container: '#am-container-custom',
        };
        const serviceModalRef = this.modalService.open(ServiceAgreementComponent, this.ngbModalOptions);
        serviceModalRef.componentInstance.serviceTermsText = this.serviceTermsText;
      }
    }, error => {
      this.isServiceSuccess = false;
      this.utilsSvc.errorHandling(error);
    });
  }

  private constructReviewData() {
    this.displayBillingCycleDropDown();
    this.constructAddRemoveList();
  }

  private mapRateplanValues(service: any) {
    const ratePlanObject = new RateplanDetails();
    let planName = _.get(service, 'name');
    let planDescription = _.get(service, 'description');
    ratePlanObject.planName = planName ? planName : planDescription;
    ratePlanObject.planStatus = _.get(service, 'status', '');
    ratePlanObject.changeEffectiveDate = _.get(this, 'nextBillingCycleDateUTC', '');
    ratePlanObject.mrc = _.get(service, 'price', '0.00');
    ratePlanObject.amountDue = 0;
    ratePlanObject.subLineType = environment.ENABLE_ML_PTT_FEATURE ? _.get(service, 'subLineType', '') : '';
    return ratePlanObject;
  }

  private constructAddRemoveList() {
    _.each(this.servicesListCurrentState, (service, index) => {
      if (service.status !== '') {
        service['index'] = index;
        if (service.status === COMMON_CONSTANTS.SERVICE_STATUS.ADDED) {
          this.ratePlansAddedList.push(service);
        } else if (service.status === COMMON_CONSTANTS.SERVICE_STATUS.REMOVED) {
          this.ratePlansRemovedList.push(service);
        }
      }
    });
    if (!isNullOrUndefined(this.removedServicesfromStorage)) {
      _.each(this.removedServicesfromStorage, (removedService) => {
        if (!isNullOrUndefined(this.currentServicesOnLoad)) {
          _.remove(this.currentServicesOnLoad, (item: any) => {
            return item.soc === removedService.soc;
          });
        }
      });
    }
    if (!isNullOrUndefined(this.addedServicesfromStorage)) {
      if (!isNullOrUndefined(this.currentServicesOnLoad)) {
        this.currentServicesOnLoad = this.currentServicesOnLoad.concat(this.addedServicesfromStorage);
        this.currentServicesOnLoad = _.uniqBy(this.currentServicesOnLoad, 'soc');
      }
    }

    this.ratePlansAddedListforApi = this.currentServicesOnLoad;
    this.ratePlansRemovedListforAPi = _.uniqBy(this.removedServicesfromStorage, 'soc');
    //logic for getting promotionList
    this.getPromotionList();
    let ratePlanObj = new RateplanDetails();

    _.each(this.ratePlansAddedListforApi, (service) => {
      ratePlanObj = this.mapRateplanValues(service);
      this.ratePlansDetailsList.push(ratePlanObj);
    });
    _.each(this.ratePlansRemovedListforAPi, (service) => {
      ratePlanObj = this.mapRateplanValues(service);
      this.ratePlansDetailsList.push(ratePlanObj);
    });
  }
  getPromotionList(){
    if (!isNullOrUndefined(this.promoListfromStorage) && this.enableMultiPromo && !isNullOrUndefined(this.ratePlansRemovedListforAPi)) {
      for (const ratePlans of this.ratePlansRemovedListforAPi) {
        for (const promotionList of this.promoListfromStorage) {
          this.promoArray = {};
          if (ratePlans?.soc === promotionList?.soc) {
            this.promoArray['soc'] = promotionList?.soc;
            this.promoArray['desc'] = promotionList?.description;
            this.promotionLists.push(this.promoArray);
          }
        }
      }
    }
  }
  private displayBillingCycleDropDown() {
    if (!_.isEmpty(this.nextBillCycleStartDate) && !_.isUndefined(this.nextBillCycleStartDate)) {
      const nextBillingCycle_timeZone = this.nextBillCycleStartDate.slice(10).replace('-', ' ');
      const convertedNextBillingCycleDate = this.nextBillCycleStartDate.slice(0, 10) + nextBillingCycle_timeZone;
      const nextBillingCycleDate = new Date(convertedNextBillingCycleDate.replace(/-/g, '/'));
      this.nextBillingCycleDateUTC = nextBillingCycleDate.toISOString();
      this.displayBillingDateInReviewScreen = this.displayBillingDateInUI(this.nextBillCycleStartDate.slice(0, 10), 'yyyy-mm-dd', '-');
      this._cacheSvc.putInSessionStoarage("ChangeServiceDate", this.displayBillingDateInReviewScreen);
    }
  }
  displayBillingDateInUI(_date: any, _format: any, _delimiter: any) {
    if (!_.isEmpty(this.nextBillCycleStartDate) && !_.isUndefined(this.nextBillCycleStartDate)) {
      let formatLowerCase = _format.toLowerCase();
      let formatItems = formatLowerCase.split(_delimiter);
      this.dateItems = _date.split(_delimiter);
      let monthIndex = formatItems.indexOf('mm');
      this.dayIndex = formatItems.indexOf('dd');
      this.yearIndex = formatItems.indexOf('yyyy');
      this.month = parseInt(this.dateItems[monthIndex]);
      this.month -= 1;
      this.monthNames = [
        'January', 'February', 'March',
        'April', 'May', 'June', 'July',
        'August', 'September', 'October',
        'November', 'December'];
    }
    let day = this.dateItems[this.dayIndex];
    let mon = this.monthNames[this.month];
    let year = this.dateItems[this.yearIndex];
    if (mon === undefined || day === undefined || year === undefined) {
      return _date;
    } else {
      day = day.length === 1 ? '0' + day : day;
      return mon + ' ' + day + ', ' + year;
    }
  }


}
